import {
    SpacingToken,
    UiRadioGroup,
    UiStack,
} from '@experiences/ui-common';
import React, {
    useCallback,
    useState,
} from 'react';
import { useIntl } from 'react-intl';

import type { StepComponentProps } from '../../constants';
import { GovernancePolicyStepNavigation } from '../../subcomponent/GovernancePolicyStepNavigation';

interface EnforcementModeData {
    mode: 'simulate' | 'activate' | 'inactive';
}

export const GovernancePolicyCreateEnforcementStep: React.FC<StepComponentProps> = ({
    onNext,
    onBack,
}) => {
    const [ selectedMode, setSelectedMode ] = useState<string>('simulate');
    const { formatMessage: translate } = useIntl();

    const handleNext = useCallback(() => {
        const data: EnforcementModeData = { mode: selectedMode as EnforcementModeData['mode'] };
        onNext(data);
    }, [ selectedMode, onNext ]);

    const handleBack = useCallback(() => {
        if (onBack) {
            onBack();
        }
    }, [ onBack ]);

    const handleModeChange = useCallback((mode: string) => {
        setSelectedMode(mode);
    }, []);

    const radioOptions = [
        {
            label: translate({ id: 'CLIENT_GOVERNANCE_ENFORCEMENT_MODE_SIMULATE' }),
            value: 'simulate',
            'data-cy': 'enforcement-mode-simulate',
        },
        {
            label: translate({ id: 'CLIENT_GOVERNANCE_ENFORCEMENT_MODE_ACTIVATE' }),
            value: 'activate',
            'data-cy': 'enforcement-mode-activate',
        },
        {
            label: translate({ id: 'CLIENT_GOVERNANCE_ENFORCEMENT_MODE_INACTIVE' }),
            value: 'inactive',
            'data-cy': 'enforcement-mode-inactive',
        },
    ];

    return (
        <UiStack
            direction="column"
            h="100%"
            justify="between"
            data-cy='governance-policy-create-enforcement-step'>
            <UiStack
                direction="column"
                gap={SpacingToken.L}>
                <UiRadioGroup
                    orientation='vertical'
                    label={translate({ id: 'CLIENT_GOVERNANCE_ENFORCEMENT_MODE_LABEL' })}
                    value={selectedMode}
                    onChange={handleModeChange}
                    options={radioOptions}
                    data-cy="enforcement-mode-radio-group"
                />
            </UiStack>

            <GovernancePolicyStepNavigation
                onNext={handleNext}
                onBack={handleBack}
                backLabel={translate({ id: 'CLIENT_BACK' })}
                nextLabel={translate({ id: 'CLIENT_NEXT' })}
            />
        </UiStack>
    );
};
